export default {
  promoter_id: '',
  promoter_name: '',
};
